// const ImageUrl="http://127.0.0.1:8000/public";
// const ImageUrl="https://microfinance.amyfintech.com/backend/public";
const ImageUrl = "https://drnwealthgroup.amyfintech.com/backend/public";
// const ImageUrl="https://microfinance.msrcrestcapital.com/backend/public";
// const ImageUrl="https://nalanfs.com/finance/backend/public";

export default ImageUrl;
